import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from "@/components/ui/card";

export function Incidents() {
	return (
		<div className="container max-w-3xl mx-auto p-6">
			<Card>
				<CardHeader>
					<CardTitle>Incidents</CardTitle>
					<CardDescription></CardDescription>
				</CardHeader>
				<CardContent></CardContent>
			</Card>
		</div>
	);
}
